function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useState, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { fontStyle, spacing, themeLight, icons } from '@naf/theme';
import { Text, TextVariant } from '@naf/text';
import { KeyboardArrowDown } from '@styled-icons/material/KeyboardArrowDown';
import isPropValid from "@emotion/is-prop-valid";
const propValidationConfig = {
  shouldForwardProp: prop => isPropValid(prop.toString())
};
export const Accordion = /*#__PURE__*/forwardRef(({
  children,
  label,
  size = 'medium',
  maxWidth,
  onOpen,
  openByDefault,
  className,
  ...rest
}, ref) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (openByDefault) {
      setOpen(openByDefault);
    }
  }, [openByDefault]);
  const labelVariant = size => {
    switch (size) {
      case 'small':
        return TextVariant.BodyTextHeader;
      case 'medium':
        return TextVariant.ArticleTextHeader;
      case 'large':
        return TextVariant.Header3;
      default:
        return TextVariant.ArticleTextHeader;
    }
  };
  return /*#__PURE__*/React.createElement(Container, _extends({
    ref: ref,
    maxWidth: maxWidth,
    size: size,
    className: className
  }, rest), /*#__PURE__*/React.createElement(StyledText, {
    tag: "h3",
    variant: labelVariant(size)
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      setOpen(!open);
      onOpen && onOpen();
    },
    "aria-expanded": open,
    type: "button"
  }, label, /*#__PURE__*/React.createElement(IconWrap, {
    isOpen: open
  }, /*#__PURE__*/React.createElement(KeyboardArrowDown, {
    size: 30
  })))), open && /*#__PURE__*/React.createElement(Content, null, children));
});
export default Accordion;
const Button = styled.button.withConfig({
  displayName: "accordion__Button",
  componentId: "sc-1wf2r38-0"
})(["border:none;margin:0;padding:0;width:auto;overflow:visible;background:transparent;color:inherit;font:inherit;line-height:normal;appearance:none;touch-action:manipulation;width:100%;text-align:start;padding-right:0;display:flex;justify-content:space-between;align-items:center;&:hover{cursor:pointer;}"]);
const IconWrap = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "accordion__IconWrap",
  componentId: "sc-1wf2r38-1"
})(["height:100%;display:flex;justify-content:center;align-items:center;margin-left:", ";", " ", " svg{font-size:", ";}"], spacing.space8, ({
  isOpen
}) => isOpen && css(["transform:rotate(180deg);transition-duration:0.3s;"]), ({
  isOpen
}) => !isOpen && css(["transform:rotate(0);transition-duration:0.3s;"]), icons.m);
const Content = styled.section.withConfig({
  displayName: "accordion__Content",
  componentId: "sc-1wf2r38-2"
})(["", ";"], fontStyle.article.articleText);
const StyledText = styled(Text).withConfig({
  displayName: "accordion__StyledText",
  componentId: "sc-1wf2r38-3"
})(["margin:0;"]);
const Container = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "accordion__Container",
  componentId: "sc-1wf2r38-4"
})(["border-bottom:1px solid;border-color:", ";", " ", " ", " ", ""], ({
  theme
}) => theme.border ? theme.border.subtle : themeLight.border.subtle, ({
  maxWidth
}) => maxWidth && css(["max-width:", "px;"], maxWidth), ({
  size
}) => size === 'small' && css(["", "{line-height:1;padding:", " 0;}", "{", ";padding-bottom:", ";}"], Button, spacing.space16, Content, fontStyle.bodyText.bodyText, spacing.space24), ({
  size
}) => size === 'medium' && css(["", "{padding:", " 0;}", "{padding-bottom:", ";}"], Button, spacing.space24, Content, spacing.space32), ({
  size
}) => size === 'large' && css(["", "{padding:", " 0;}", "{padding-bottom:", ";}"], Button, spacing.space24, Content, spacing.space32));
//# sourceMappingURL=accordion.js.map